import React, { useCallback, useEffect, useState } from "react";

import "./GenesysChat.css";

const GENESYS_SCRIPT_ID = "genesys-bootstrap-script";
const GENESYS_SCRIPT_SRC =
  "https://apps.mypurecloud.com/genesys-bootstrap/genesys.min.js";

// El deploymentId siempre es el UUID del Messenger Deployment (Admin > Message
// > Messenger Configurations), sin importar cómo se llame la variable en el
// .env de cada proyecto. Mapear explícitamente aquí si el nombre cambia.
const GENESYS_ENVIRONMENT = 'prod';
const GENESYS_DEPLOYMENT_ID = 'f7718d08-c40d-4cec-9417-5a51dd4f8de5';

function ensureGenesysBootstrap(environment, deploymentId) {
  if (typeof window.Genesys === "function") {
    return;
  }
  if (document.getElementById(GENESYS_SCRIPT_ID)) {
    return;
  }

  (function (g, e, n, es, ys) {
    g["_genesysJs"] = e;
    g[e] =
      g[e] ||
      function () {
        (g[e].q = g[e].q || []).push(arguments);
      };
    g[e].t = 1 * new Date();
    g[e].c = es;
    ys = document.createElement("script");
    ys.id = GENESYS_SCRIPT_ID;
    ys.async = 1;
    ys.src = n;
    ys.charset = "utf-8";
    document.head.appendChild(ys);
  })(window, "Genesys", GENESYS_SCRIPT_SRC, {
    environment,
    deploymentId,
  });
}

function GenesysChat() {
  const [ready, setReady] = useState(false);
  const [messengerOpen, setMessengerOpen] = useState(false);

  const isConfigured = Boolean(GENESYS_ENVIRONMENT && GENESYS_DEPLOYMENT_ID);

  useEffect(() => {
    if (!isConfigured) {
      return;
    }

    ensureGenesysBootstrap(GENESYS_ENVIRONMENT, GENESYS_DEPLOYMENT_ID);

    const genesys = window.Genesys;

    genesys("subscribe", "Messenger.ready", () => {
      setReady(true);
      genesys("command", "Launcher.hide");
    });
    genesys("subscribe", "Messenger.opened", () => setMessengerOpen(true));
    genesys("subscribe", "Messenger.closed", () => setMessengerOpen(false));
  }, [isConfigured]);

  const handleClick = useCallback(() => {
    if (!ready || typeof window.Genesys !== "function") {
      return;
    }
    window.Genesys("command", "Messenger.open");
  }, [ready]);

  if (!isConfigured) {
    return null;
  }

  return (
    <button
      type="button"
      className={
        "genesys-chat-float" +
        (messengerOpen ? " genesys-chat-float--hidden" : "")
      }
      onClick={handleClick}
      disabled={!ready}
      aria-label="Abrir chat en línea"
    >
      <svg
        aria-hidden="true"
        width="26"
        height="26"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 3C6.98 3 3 6.6 3 11c0 2.42 1.2 4.6 3.11 6.06-.13 1.14-.55 2.53-1.36 3.6a.5.5 0 0 0 .5.79c1.77-.35 3.36-1.09 4.5-1.85A11.5 11.5 0 0 0 12 19c5.02 0 9-3.6 9-8s-3.98-8-9-8Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
}

export default GenesysChat;
